export const STRINGS = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGINATION_LIMIT: 25,
};
